const componentColor = {
  appBarBackground: "#333333",
  appBarColor: "#FFFFFF",
  bodyBackground: "#666666",
};

export default componentColor;
